import { useTranslation } from "@sagot/i18n";
import { Button, Dialog, DialogContent } from "@sagot/ui";

const P = "engage.workflows.extras.paths";

interface PathDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** "Path C · Tuition". */
  pathTitle: string;
  /** Connections from other paths that lead here: they are cleared with the path. */
  connections: number;
  /** Notes written on the path: they stay as notes of the workflow. */
  notes: number;
  onConfirm: () => void;
  onCloseAutoFocus?: (event: Event) => void;
}

/** "Delete Path C · Tuition? 3 connections lead here and will be cleared." (WF-P5-12). Undo brings the path back. */
export function PathDeleteDialog({ open, onOpenChange, pathTitle, connections, notes, onConfirm, onCloseAutoFocus }: PathDeleteDialogProps) {
  const { t } = useTranslation();
  const body = connections > 0 ? t(`${P}.deleteBody`, { count: connections }) : t(`${P}.deleteBodyNone`);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        title={t(`${P}.deleteTitle`, { path: pathTitle })}
        description={notes > 0 ? `${body} ${t(`${P}.deleteNotes`, { count: notes })}` : body}
        closeLabel={t("common.close")}
        onCloseAutoFocus={onCloseAutoFocus}
        footer={
          <>
            <Button variant="secondary" onClick={() => { onOpenChange(false); }}>{t("common.cancel")}</Button>
            <Button variant="danger" onClick={() => { onOpenChange(false); onConfirm(); }}>{t(`${P}.deleteConfirm`)}</Button>
          </>
        }
      />
    </Dialog>
  );
}
